// SHARED-DES-2: the version of a seat's serves link set (04 §Optimistic concurrency), shared by the
// API, its tests and the web fake twin. Content-derived, like `seatMetricSetVersion`: `PUT
// seats/{id}/serves` under `If-Match` refuses a set someone changed since its writer read it.
// Zod-free on purpose (`@companyos/schema/seat-serves-set`; the web bundle runs under a CSP
// without `unsafe-eval`).
export type SeatServesSetLine = {
  target_kind: string;
  target_id: string | null;
  grants: { talk: boolean; task: boolean; see: boolean };
};

/** FNV-1a over the links in target order with their grants, folded to nine digits. */
export function seatServesSetVersion(lines: readonly SeatServesSetLine[]): number {
  const text = lines
    .map((l) =>
      [
        l.target_kind,
        l.target_id ?? "",
        l.grants.talk ? 1 : 0,
        l.grants.task ? 1 : 0,
        l.grants.see ? 1 : 0,
      ].join("|"),
    )
    .sort()
    .join(";");
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h % 1_000_000_000;
}
